import React, { useEffect, useState } from "react";
import Navbar from "./navbar/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GlobalLanguageLoader from "./GlobalLanguageLoader";

const Layout = () => {
  const { i18n } = useTranslation();
  const [showLangLoader, setShowLangLoader] = useState(false);

  // 🌐 Language change loader only
  useEffect(() => {
    const handleLanguageChange = () => {
      setShowLangLoader(true);

      const t = setTimeout(() => {
        setShowLangLoader(false);
      }, 500);

      return () => clearTimeout(t);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <div className="bg-gray-200 h-screen flex flex-col overflow-hidden">
      {showLangLoader && <GlobalLanguageLoader />}

      {/* Common Navbar */}
      <Navbar />

      {/* Page Content */}
      <main className="flex-1 overflow-auto px-4 py-6">
        <div className="container mx-auto">
        <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
